import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OktaAuthService } from './app.service';
import { ErrorService } from './shared/services/error.service';
import { UserPreferenceService } from './shared/services/userpreferences.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  roles: [];
  isAuthenticated: boolean;
  loaded: boolean;

  constructor(private oktaAuth: OktaAuthService,
    private errorService: ErrorService,
    private userPref: UserPreferenceService,
    private translate: TranslateService,
    private router: Router) {
    this.loaded = false;
  }

  ngOnInit(): void {
    this.oktaAuth.$isAuthenticated.subscribe(val => {
      this.isAuthenticated = val;

      if(val) {
        this.oktaAuth.getUserDetails()
          .then(res => {
            if (res.groups) {
              this.roles = res.groups.filter(g => g.startsWith("APPROLE_"))
            }
          })
          .then(() => {
            if (this.isAuthenticated && (this.roles.length > 0)) {
              // load admin data
              this.oktaAuth.storeOktaAdminTenantInfo()
                .then(res => {

                  // load and store user preferences local
                  this.userPref.getUserPreferences()
                    .then(up => {
                      if(up.language){
                        // set the default language to en
                        this.translate.setDefaultLang(up.language.toLowerCase());
                        this.translate.use(up.language.toLowerCase());
                      }else{
                        // set the default language to en
                        this.translate.setDefaultLang('en');
                        this.translate.use('en');
                      }

                      // store last login before updating it for activity info
                      if(up.lastLogin){
                        sessionStorage.setItem("lastLogin", String(up.lastLogin));
                      }

                      // updateLastLoginDate
                      this.userPref.userUpdateLastLogin()
                        .catch(err => {
                          throw err;
                        });

                      this.loaded = true;

                      // check to see if multiple tenants are available, and if one has been selected
                      let tenants = JSON.parse(sessionStorage.getItem("okta-tenants"));
                      if(tenants && tenants.availableTenants.length > 1 && !tenants.selectedTenant){
                        // multiple tenants available but no tenants selected so redirect to that page
                        this.router.navigate(['/tenants']);
                      }

                    })
                    .catch(err => {
                      this.loaded = true;
                      this.errorService.handlerError(err);
                    });
                  });
            } else {
              // if auth failed, e.g. user not assigned the app or doesn't have any roles
              this.loaded = true;
              this.router.navigateByUrl('/not-assigned');
            }
          });
      }
    });

    // reset errors on page nav
    this.router.events.subscribe(event =>{
      if (event instanceof NavigationStart){
        this.errorService.reset();
      }
   })

  }
}
